import { defaultAxios, IParams } from '../base';

export interface IMutateSavePreRequestTemp extends IParams {
  preRequestSeq: number;
  custSeq: number;
  purposeCd: string;
  haveCnt: string;
  disposalPlanYn: 'Y' | 'N';
  houseType: string;
  ldongCode: string;
  apartment: string;
  floor: string;
  dong: number;
  ho: number;
  hopefulAmt: number;
  previousYn: 'Y' | 'N';
  previousAmt: number;
  tenantYn: 'Y' | 'N';
  tenantAmt: number;
  marriageCd: string;
  jobType: string;
  salaryAmt: number;
  openDt: string;
  credPoint: number;
  firstYn: 'Y' | 'N';
  houseAmt: number;
}

// 주담대 가심사 신청 정보 저장 (임시 저장)
export const mutateSavePreRequestTemp = async (
  params: IMutateSavePreRequestTemp,
) => {
  return await defaultAxios().put(`/house/savePreRequestTemp`, params);
};
